<template>
  <v-row class="fill-height white">
    <v-col cols="12" sm="6">
      <v-card
        flat
        :class="$vuetify.breakpoint.mobile ? '' : 'pl-15 pr-15 ml-15 mr-15'"
      >
        <v-progress-circular
          color="orange"
          indeterminate
          class="mx-auto"
          size="150"
          v-if="loading"
        ></v-progress-circular>

        <v-card-text style="height: 90vh; overflow: auto" v-else-if="pos_plan">
          <h1
            class="text-center orange--text font-weight-black"
            style="margin-top: 20%"
          >
            Subscribe now to continue for
          </h1>
          <h1 class="text-center orange--text text-h2 mt-4" v-if="pos_plan">
            {{ pos_plan.base_currency_code
            }}{{ pos_plan.amount | toMoney }}/Month
          </h1>
          <p
            v-if="isGhanaBusiness && pos_plan"
            class="text-center text-body-2 grey--text text--darken-1 mt-2 mb-0"
          >
            Base subscription rate
            <strong class="orange--text">
              {{ pos_plan.base_currency_code }}{{ pos_plan.amount | toMoney }}
            </strong>
            per month before your billing period and statutory levies.
          </p>
          <v-form class="mt-5">
            <v-autocomplete
              v-model="cycle"
              :items="cycles"
              outlined
              placeholder="Select your billing cycle"
              color="orange"
              item-color="orange"
            ></v-autocomplete>
          </v-form>

          <v-sheet
            v-if="isGhanaBusiness && pos_plan"
            color="grey lighten-5"
            rounded="lg"
            elevation="0"
            class="pa-4 mt-4 text-left mx-auto plan-pricing-sheet"
            max-width="440"
          >
            <template v-if="DISCOUNT_AMOUNT > 0">
              <div
                class="d-flex justify-space-between caption grey--text text--darken-1"
              >
                <span>Before coupon</span>
                <span style="text-decoration: line-through">{{
                  pos_plan.base_currency_code
                }}{{ AMOUNT | toMoney }}</span>
              </div>
              <div
                class="d-flex justify-space-between py-1 success--text caption"
              >
                <span>Coupon ({{ discountP }}%)</span>
                <span
                  >− {{ pos_plan.base_currency_code
                  }}{{ DISCOUNT_AMOUNT | toMoney }}</span
                >
              </div>
            </template>
            <div class="d-flex justify-space-between py-2 body-1">
              <span>Subscription base (before taxes)</span>
              <strong
                >{{ pos_plan.base_currency_code
                }}{{ subscriptionPayableSubtotal | toMoney }}</strong
              >
            </div>
            <div
              class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
            >
              <span>VAT (15% of base)</span>
              <span>{{ pos_plan.base_currency_code
              }}{{ ghanaVatAmount | toMoney }}</span>
            </div>
            <div
              class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
            >
              <span>NHIL (2.5% of base)</span>
              <span>{{ pos_plan.base_currency_code
              }}{{ ghanaNhilAmount | toMoney }}</span>
            </div>
            <div
              class="d-flex justify-space-between py-1 grey--text text--darken-1 body-2"
            >
              <span>GETFund levy (2.5% of base)</span>
              <span>{{ pos_plan.base_currency_code
              }}{{ ghanaGetfundAmount | toMoney }}</span>
            </div>
            <v-divider class="my-2"></v-divider>
            <div
              class="d-flex justify-space-between text-h6 orange--text font-weight-bold"
            >
              <span>Total payable</span>
              <span>{{ pos_plan.base_currency_code
              }}{{ subscriptionChargeAmount | toMoney }}</span>
            </div>
          </v-sheet>

          <template v-else-if="pos_plan">
            <p
              class="text-center font-weight-light text-h5"
              :class="DISCOUNT_AMOUNT > 0 ? 'cancel' : ''"
            >
              Amount:{{ pos_plan.base_currency_code }}{{ AMOUNT | toMoney }}
            </p>

            <p
              v-if="DISCOUNT_AMOUNT > 0"
              class="text-center font-weight-light text-h5"
            >
              Discount:{{ pos_plan.base_currency_code
              }}{{ DISCOUNT_AMOUNT | toMoney }}({{ discountP }}%)
            </p>

            <p
              v-if="DISCOUNT_AMOUNT > 0"
              class="text-center font-weight-light text-h5"
            >
              Amount Due:{{ pos_plan.base_currency_code
              }}{{ AMOUNT_DUE | toMoney }}
            </p>
          </template>

          <v-btn
            @click="showMobileMoneyCheckout = true"
            v-if="HAS_MOBILE_MONEY"
            block
            color="orange"
            dark
            rounded
            x-large
            depressed
            class="mt-5"
            >Pay with mobile Money</v-btn
          >
          <v-btn
            :loading="card_loading"
            @click="subscribeWithCard"
            :disabled="!pos_plan || !cardIntervalIsValid(cycle)"
            block
            color="orange"
            :outlined="HAS_MOBILE_MONEY"
            dark
            rounded
            x-large
            depressed
            class="mt-5"
            >Pay with Card</v-btn
          >
          <v-card
            v-if="pos_plan && !cardIntervalIsValid(cycle)"
            color="blue-grey lighten-5"
            class="mt-3"
            outlined
            style="border-left: 4px solid #ff9800; border-radius: 8px"
          >
            <v-card-text class="pa-3 text-left">
              <div class="d-flex align-start">
                <v-icon small color="orange darken-2" class="mr-2 mt-1"
                  >mdi-information-outline</v-icon
                >
                <div class="body-2 grey--text text--darken-1 text-left">
                  Card payments are only available for monthly, quarterly, every
                  6 months, or annual billing cycles.
                </div>
              </div>
            </v-card-text>
          </v-card>
          <v-btn
            @click="showCouponDialog = true"
            class="mt-3"
            color="orange"
            rounded
            block
            text
            depressed
            x-large
            >Apply coupon
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="6"
      class="orange white--text text-center"
      style="height: 100vh; position: relative"
      v-if="!$vuetify.breakpoint.mobile"
    >
      <div class="vertical-center text-center mx-auto" style="width: 100%">
        <v-img
          width="200"
          class="mx-auto"
          style="margin-top: 20%"
          src="/img/clock_stop.svg"
        ></v-img>
        <p class="text-h2 mt-10 text-center">
          Hello {{ $store.state.user.first_name }},
        </p>
        <p class="text-h5 font-weight-light ma-4">
          Your subscription to
          <img
            width="60"
            class="mt-2"
            src="https://built.africa/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Flogo2.d9c417ee.png&w=828&q=75"
          />POS for
          <strong class="font-weight-black">{{
            $store.state.user.current_business.name
          }}</strong>
          has ended
        </p>
        <v-btn @click="showLogout = true" color="orange lighten-5" text small
          >Log Out</v-btn
        >
      </div>
    </v-col>

    <v-dialog
      v-if="pos_plan"
      width="500"
      :persistent="$store.state.momo.progress"
      v-model="showMobileMoneyCheckout"
    >
      <v-card>
        <checkout
          :amount="subscriptionChargeAmount"
          :account_id="0"
          :record_id="cycle"
          :cost-breakdown="ghanaCostBreakdown"
          :discounted-price="subscriptionChargeAmount"
          :is-eligible-for-discount="false"
          :momo-subscription-options="
            isGhanaBusiness ? momoSubscriptionCheckoutOptions : null
          "
          @paymentComplete="send_success"
          :record_type="'subscription-' + pos_plan.name.toLowerCase()"
        >
        </checkout>
      </v-card>
    </v-dialog>

    <v-dialog width="500" v-model="showLogout">
      <v-card>
        <v-card-title>Confirm Logout</v-card-title>
        <v-card-text>
          <h1 class="font-weight-light">Do you want to logout?</h1>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="loggingOut"
            @click="logOut"
            color="red"
            block
            rounded
            depressed
            x-large
            dark
            >Logout</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      width="400"
      v-model="showCouponDialog"
      :persistent="couponLoading"
    >
      <v-card>
        <v-card-title>Redeem your coupon</v-card-title>
        <v-card-text>
          <v-form ref="couponForm">
            <v-text-field
              color="orange"
              v-model="couponCode"
              outlined
              placeholder="Enter coupon code"
              :rules="[store.state.validationRules.required]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            color="orange"
            depressed
            dark
            rounded
            :loading="couponLoading"
            x-large
            @click="redeemCoupon"
            >Apply Coupon
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { defineComponent } from "vue";
import PhoneNumberInput from "./PhoneNumberInput.vue";
import store from "../store";
import moment from "moment";
import Checkout from "./Checkout.vue";

const CARD_INTERVALS = [
  {
    months: 1,
    value: "monthly",
    label: "Monthly",
    description: "charged every month",
  },
  {
    months: 3,
    value: "quarterly",
    label: "Quarterly",
    description: "charged every 3 months",
  },
  {
    months: 6,
    value: "six_months",
    label: "Six months",
    description: "charged every 6 months",
  },
  {
    months: 12,
    value: "annually",
    label: "Annually",
    description: "charged once a year",
  },
];

export default defineComponent({
  name: "SubscribeComponent",
  components: { Checkout, PhoneNumberInput },
  data() {
    return {
      showCouponDialog: false,
      showLogout: false,
      loggingOut: false,
      plans: [],
      loading: false,
      couponLoading: false,
      card_loading: false,
      couponCode: "",
      discountP: 0,
      showMobileMoneyCheckout: false,
      /** Last successfully applied coupon code (for MoMo subscription API); cleared on reload. */
      redeemedSubscriptionCouponCode: "",
      cycle: 3,
      cycles: [
        {
          value: 1,
          text: "Monthly",
        },
        {
          value: 3,
          text: "Every three months",
        },
        {
          value: 4,
          text: "Every four months",
        },
        {
          value: 5,
          text: "Every five months",
        },
        {
          value: 6,
          text: "Every six months",
        },
        {
          value: 7,
          text: "Every seven months",
        },
        {
          value: 8,
          text: "Every eight months",
        },
        {
          value: 9,
          text: "Every nine months",
        },
        {
          value: 10,
          text: "Every ten months",
        },
        {
          value: 11,
          text: "Every eleven months",
        },
        {
          value: 12,
          text: "Annually",
        },
        {
          value: 24,
          text: "Every two years",
        },
      ],
    };
  },
  computed: {
    HAS_MOBILE_MONEY() {
      const country_codes = ["GH", "SL", "KE", "RW"];

      return (
        this.business && country_codes.includes(this.business.country.code)
      );
    },
    business() {
      return this.store.state.user.current_business;
    },
    store() {
      return store;
    },
    pos_plan() {
      return this.plans.find((plan) => {
        return plan.name.toLowerCase() === "starter";
      });
    },

    DISCOUNT_AMOUNT() {
      if (this.discountP > 0) {
        return (this.discountP / 100) * this.AMOUNT;
      }

      return 0;
    },
    AMOUNT() {
      if (this.pos_plan) {
        return this.pos_plan.amount * this.cycle;
      }

      return 0;
    },
    AMOUNT_DUE() {
      return this.AMOUNT - this.DISCOUNT_AMOUNT;
    },

    isGhanaBusiness() {
      return (this.business?.country?.code || "").toUpperCase() === "GH";
    },

    /** Net subscription for selected cycle, after coupon (Ghana tax base). */
    subscriptionPayableSubtotal() {
      return this.roundMoney(this.AMOUNT_DUE);
    },

    ghanaVatAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.15);
    },

    ghanaNhilAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.025);
    },

    ghanaGetfundAmount() {
      if (!this.isGhanaBusiness) return 0;
      return this.roundMoney(this.subscriptionPayableSubtotal * 0.025);
    },

    /** Amount charged: Ghana includes VAT + NHIL + GETFund on net base. */
    subscriptionChargeAmount() {
      if (!this.isGhanaBusiness) {
        return this.roundMoney(this.AMOUNT_DUE);
      }
      return this.roundMoney(
        this.subscriptionPayableSubtotal +
          this.ghanaVatAmount +
          this.ghanaNhilAmount +
          this.ghanaGetfundAmount,
      );
    },

    ghanaCostBreakdown() {
      if (!this.isGhanaBusiness) return null;
      return {
        base: this.subscriptionPayableSubtotal,
        vat: this.ghanaVatAmount,
        nhil: this.ghanaNhilAmount,
        getfund: this.ghanaGetfundAmount,
        total: this.subscriptionChargeAmount,
      };
    },

    /** Enables /api/init-momo-subscription in Checkout for Ghana subscription MoMo only. */
    momoSubscriptionCheckoutOptions() {
      if (!this.pos_plan) return null;
      return {
        interval: this.cycle,
        plan_name: this.pos_plan.name.toLowerCase(),
        coupon: this.redeemedSubscriptionCouponCode || "",
        current_plan_id: "",
        change_current_plan_id: "",
      };
    },
  },
  methods: {
    roundMoney(value) {
      return Math.round(Number(value || 0) * 100) / 100;
    },

    cardIntervalEntry(months) {
      return CARD_INTERVALS.find((entry) => entry.months === months);
    },

    intervalFromMonths(months) {
      const entry = this.cardIntervalEntry(months);
      return entry ? entry.value : null;
    },

    cardIntervalIsValid(months) {
      return Boolean(this.intervalFromMonths(months));
    },

    send_success() {
      location.reload();
    },
    send_success_direct() {
      this.progress = true;
      let formData = new FormData();
      formData.append("startdate", moment().format("Y-M-D"));
      formData.append(
        "enddate",
        moment().add(this.cycle, "months").format("Y-M-D"),
      );
      formData.append("amount", this.subscriptionChargeAmount);
      formData.append("plan", this.pos_plan.name);
      formData.append("coupon_applied", this.discountP > 0);
      formData.append("coupon_code", this.couponCode);
      formData.append("billing_cycle", this.cycle);
      axios
        .post("/api/appsubcription", formData)
        .then((res) => {
          this.progress = false;
          location.reload();
        })
        .catch((error) => {
          this.progress = false;
        });
    },
    redeemCoupon() {
      if (this.$refs.couponForm.validate()) {
        this.couponLoading = true;

        axios
          .post("/api/coupon", {
            code: this.couponCode,
          })
          .then((res) => {
            this.discountP = res.data.discount;
            this.couponLoading = false;
            this.showCouponDialog = false;
            this.redeemedSubscriptionCouponCode = this.couponCode || "";
            this.couponCode = "";
            if (this.discountP >= 100) {
              this.send_success_direct();
            }
          })

          .catch(() => {
            this.couponLoading = false;
          });
      }
    },

    logOut() {
      this.loggingOut = true;

      axios
        .get("/api/auth/logout")
        .then((res) => {
          this.loggingOut = false;
          window.location.reload();
        })
        .catch(() => {
          this.loggingOut = false;
        });
    },
    getPlans() {
      this.loading = true;
      axios
        .get(
          "/api/subscriptionplans/" +
            this.$store.state.user.current_business.country_id,
        )
        .then((res) => {
          this.plans = res.data;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    subscribeWithCard() {
      const planName = this.pos_plan?.name;
      if (!planName || !this.cardIntervalIsValid(this.cycle)) {
        return;
      }

      this.card_loading = true;
      const interval =
        this.intervalFromMonths(this.cycle) || "monthly";

      const payload = {
        plan_name: planName,
        interval,
      };

      axios
        .post("/api/stripe/init-subscription", payload)
        .then((res) => {
          window.open(res.data.url);
          this.card_loading = false;
        })
        .catch(() => {
          this.card_loading = false;
        });
    },
  },
  mounted() {
    this.getPlans();
    this.discountP = 0;
    this.redeemedSubscriptionCouponCode = "";
  },
});
</script>

<style>
.cancel {
  text-decoration: line-through;
}

.plan-pricing-sheet {
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.v-btn.v-btn--disabled {
  background-color: #e0e0e0 !important;
  color: #9e9e9e !important;
  opacity: 1 !important;
}
</style>
